<template>
  <div class="Melamine">
    <div class="title">Isopropyl Alcohol</div>

    <div class="table">
      <label>Specification:</label>
      <el-table border :data="tableData" stripe>
        <!-- <el-table-column prop="NO" label="NO." width="100"> </el-table-column> -->
        <el-table-column prop="Item" label="Item"> </el-table-column>
        <el-table-column prop="Property" label="Property"> </el-table-column>
      </el-table>
    </div>
    <div class="item-huanhang">
      <label>Package:</label>
      <p>
        In 160kg drums, 12.8mt/20'FCL and 24.32mt/40'FCL. In 800kg IBC drums,
        16mt/20'FCL and 26.4mt/40'FCL. Or in 18.6mt ISO tanks, Or in Bulk
        vessel.
      </p>
    </div>
    <div class="item-huanhang">
      <label>Uses:</label>
      <p>
        It is used in the manufacture of a wide variety of industrialand
        household chemicals, and is a common ingredient in chemicals such as
        antiseptics, disinfectanits and detergents.
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ACTdetail",
  data() {
    return {
      tableData: [
        {
          NO: "1",
          Item: "Purity wt%",
          Property: "99.9MIN.",
        },
        {
          NO: "2",
          Item: "Colour Pt-Co(Hazen)wt%",
          Property: "10 APHA Max.",
        },
        {
          NO: "3",
          Item: "Water wt%",
          Property: "0.2Max",
        },
        {
          NO: "4",
          Item: "Sp.Gr. at 20/20 C(g m3)",
          Property: "0.785-0.786",
        },
        {
          NO: "5",
          Item: "Water miscibility",
          Property: "pass",
        },
        {
          NO: "6",
          Item: "Acidity wt%(As Acetic Acid)",

          Property: "",
        },
        {
          NO: "7",
          Item: "Non-volatile matter mg/100ml",
          Property: "2.0 Max",
        },
        {
          NO: "8",
          Item: "Carbonyl(acetone)",
          Property: "0.02",
        },
        {
          NO: "9",
          Item: "Sulfide(S) (mg kg)",
          Property: "2",
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.Melamine {
  padding: 10px 30px;
  height: 100%;
  overflow-y: auto;
  label {
    font-size: 20px;
    font-weight: bold;
    height: 40px;
    line-height: 40px;
  }
  p {
    color: gray;
    font-weight: bold;
    line-height: 30px;
  }
  .title {
    font-size: 30px;
    font-weight: bold;
    color: #042a42cf;
  }
  .table {
    margin-top: 10px;
    display: flex;
    flex-direction: column;
  }
  .item {
    margin-top: 10px;
    display: flex;
    align-items: center;
    column-gap: 10px;
  }
  .item-huanhang {
    display: flex;
    flex-direction: column;
    column-gap: 20px;
  }
}
</style>
